<template>
  <div v-bind:id="`accept-` + job.job_id" class="margin-bottom-2">
    <div class="job-link component position-relative">
      <!-- If it's a candidate -->
      <template v-if="!company">
        <div class="card" :class="job.is_declined ? 'declined' : ''">
          <div class="card-top-row">
            <div v-if="parseInt(job.is_declined)" class="declined">Afgewezen</div>
            <div v-if="parseInt(job.percentage) && sub_branch != '2'" class="match_percentage">{{ parseInt(job.percentage) }}% match</div>
            <div v-if="parseInt(job.is_interested)" class="bell"><svg-icon icon="notification_bell" /></div>
            <div v-if="accept" class="icon-wrapper float-left mt-2"><svg-icon icon="thumbs_up" /></div>
          </div>
          <div class="card-body" :class="accept || highlight || (job.applicants_count && user.type == 2) ? 'sd-highlighted' : ''">
            <div class="card-body-inner" :class="[arrow ? 'w-arrow' : 'no-arrow']">
              <div class="jobCardSpecs-image">
                <img v-if="job.company_avatar" :src="job.company_avatar" class="img-item" />
                <svg-icon v-else-if="job.sub_branch == '2'" icon="school_vo" class="img-item"/>
                <svg-icon v-else icon="education" class="img-item"/>
              </div>
              <div class="jobCardSpecs">
                <router-link :to="{ name: 'job', params: params}">
                  <ul>
                    <template v-if="sub_branch == '2' || (sub_branch == '1' && job.duration_type == 1)">
                      <li >
                        <svg-icon icon="calendar"></svg-icon>
                        <b>Start: {{ getFirstWorkingDate() }}</b>
                        <span class="duration_type recent_yellow" v-if="sub_branch == '1' && job.duration_type == 1">Langdurig</span>
                      </li>
                      <li>
                        <svg-icon icon="calendar"></svg-icon>
                        <b>Eind: {{ getLastWorkingDate() }}</b>
                      </li>
                    </template>
                    <li v-else-if="subtitle">
                      <svg-icon icon="calendar"></svg-icon>
                      <b>Start: {{ subtitle[0] }}</b>
                      <span class="duration_type recent">{{ subtitle[1] }}</span>
                    </li>
                    <template v-if="job.sub_branch == '1'">
                      <li v-if="formattedAudience"><svg-icon icon="blackboard"></svg-icon>Groep {{ formattedAudience }}</li>
                      <li v-if="job.city">
                        <svg-icon icon="marker"></svg-icon>
                        <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
                        <span v-else-if="job.company_name && !company">{{ job.company_name }}</span>
                        <span v-else>{{ job.city }}</span>
                      </li>
                    </template>
                    <template v-if="job.sub_branch == '2'">
                      <li><svg-icon icon="blackboard"></svg-icon>{{ job.subject }}, {{ formattedGroup }}</li>
                      <li><svg-icon icon="diploma"></svg-icon>{{ formattedAudience }} klas</li>
                      <li v-if="job.city">
                        <svg-icon icon="marker"></svg-icon>
                        <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
                        <span v-else-if="job.company_name && !company">{{ job.company_name }}</span>
                        <span v-else>{{ job.city }}</span>
                      </li>
                    </template>

                  </ul>
                </router-link>
              </div>
            </div>
            <router-link
              v-if="arrow"
              :to="{ name: 'job', params: params }"
              class="arrow position-absolute d-block h-100"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
            <span class="icon-wrapper position-absolute">
              <svg-icon icon="chevron_e" />
            </span>
            </router-link>
            <button
              v-if="accept"
              v-on:click.stop="onAccept(job.matched_applicant_id)"
              type="button"
              class="btn btn-light btn-block"
            >
              Accepteren
            </button>
          </div>
        </div>
      </template>
      <!-- If it's a company -->
      <template v-if="company">
        <div class="card">
          <div class="card-top-row">
            <div v-if="parseInt(job.percentage) && sub_branch != '2'" class="match_percentage">
              {{ parseInt(job.percentage) }}% match
            </div>
            <div v-if="parseInt(job.is_interested)" class="bell">
              <svg-icon icon="notification_bell" />
            </div>
          </div>
          <div class="card-body" :class="accept || highlight || (job.applicants_count && user.type == 2) ? 'sd-highlighted' : ''">
            <div class="card-body-inner" :class="[arrow ? 'w-arrow' : 'no-arrow', company ? 'company-card' : '']">
              <div v-if="accept" class="icon-wrapper float-left mt-2">
                <svg-icon icon="thumbs_up" />
              </div>
              <div class="jobCardSpecs-image">
                <img v-if="job.company_avatar" :src="job.company_avatar" class="img-item" />
                <svg-icon v-else-if="job.sub_branch == '2'" icon="school_vo" class="img-item"/>
                <svg-icon v-else icon="education" class="img-item"/>
              </div>
              <div class="jobCardSpecs">
                <router-link :to="{ name: 'job', params: params}">
                  <ul>
                    <template v-if="sub_branch == '2' || (sub_branch == '1' && job.duration_type == 1)">
                      <li >
                        <svg-icon icon="calendar"></svg-icon>
                        <b>Start: {{ getFirstWorkingDate() }}</b>
                        <span class="duration_type recent_yellow" v-if="sub_branch == '1' && job.duration_type == 1">Langdurig</span>
                      </li>
                      <li>
                        <svg-icon icon="calendar"></svg-icon>
                        <b>Eind: {{ getLastWorkingDate() }}</b>
                      </li>
                    </template>
                    <li v-else-if="subtitle">
                      <svg-icon icon="calendar"></svg-icon>
                      <b>Start: {{ subtitle[0] }}</b>
                      <span class="duration_type recent">{{ subtitle[1] }}</span>
                    </li>
                    <template v-if="sub_branch == '1'">
                      <li v-if="formattedAudience"><svg-icon icon="blackboard"></svg-icon>Groep {{ formattedAudience }}</li>
                      <li v-if="job.city">
                        <svg-icon icon="marker"></svg-icon>
                        <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
                        <span v-else>{{ job.city }}</span>
                      </li>
                      <li v-if="job.company_name && !company"><svg-icon icon="education"></svg-icon>{{ job.company_name }}</li>
                    </template>
                    <template v-if="sub_branch == '2'">
                      <li><svg-icon icon="blackboard"></svg-icon>{{ job.subject }} - {{ formattedGroup }}</li>
                      <li><svg-icon icon="diploma"></svg-icon>{{ formattedAudience }} klas</li>
                      <li v-if="job.city && Object.keys(user.addresses).length > 1">
                        <svg-icon icon="marker"></svg-icon>
                        <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
                        <span v-else>{{ job.city }}</span>
                      </li>
                    </template>
                    <template v-if="!open">
                      <li>
                        <router-link
                          v-if="job.applicants_count"
                          :to="{ name: 'job-applicants', params: { id: parseInt(job.id) } }"
                          class="people-overview applicants"
                          v-ripple="'rgba(255, 255, 255, 0.35)'"
                        >
                          <span v-for="index in job.applicants_count" :key="index" v-if="index <= 4" class="profile-circle">{{ index }}</span>
                          <span v-if="job.applicants_count > 4" class="profile-circle">+{{ job.applicants_count - 4 }}</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          v-if="job.matches_count"
                          :to="{ name: 'job-matches', params: { id: parseInt(job.id) } }"
                          class="people-overview recommendations"
                          v-ripple="'rgba(255, 255, 255, 0.35)'"
                        >
                          <span v-for="index in job.matches_count" :key="index" v-if="index <= 4" class="profile-circle">{{ index }}</span>
                          <span v-if="job.matches_count > 4" class="profile-circle">+{{ job.matches_count - 4 }}</span>
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </router-link>
              </div>
            </div>
            <router-link
              v-if="arrow"
              :to="{ name: 'job', params: params }"
              class="arrow position-absolute d-block h-100"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              <span class="icon-wrapper position-absolute">
                <svg-icon icon="chevron_e" />
              </span>
            </router-link>
            <button
              v-if="accept"
              v-on:click.stop="onAccept(job.matched_applicant_id)"
              type="button"
              class="btn btn-light btn-block"
            >
              Accepteren
            </button>
            <div class="control-bar">
              <div class="control-bar-top">
                <router-link
                  v-if="job.applicants_count"
                  :to="{ name: 'job-applicants', params: { id: parseInt(job.id) } }"
                  class="sd-button btn btn-warning"
                  v-ripple="'rgba(255, 255, 255, 0.35)'"
                >
                  Bekijk sollicitaties
                </router-link>
                <router-link
                  v-if="job.matches_count"
                  :to="{ name: 'job-matches', params: { id: parseInt(job.id) } }"
                  class="sd-button btn btn-warning"
                  v-ripple="'rgba(255, 255, 255, 0.35)'"
                >
                  Bekijk matches
                </router-link>
              </div>
              <div class="control-bar-bottom">
                <router-link
                  :to="{ name: 'job', params: params}"
                  class="sd-button text-link"
                  v-ripple="'rgba(255, 255, 255, 0.35)'"
                >
                  Bekijk vacature
                </router-link>
                <a v-if="!this.closed" class="sd-button text-link" @click="editJob" role="button" >Bewerken</a>
                <a v-if="!this.closed" class="sd-button delete" @click="deleteJob" role="button"><svg-icon icon="trash" /></a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      branch: localStorage.getItem("branch"),
      sub_branch: localStorage.getItem("subBranch"),
      user: null,
      city: null,
      applicants: null,
      subtitle: [],
      formattedAudience: null,
      formattedgroup: null,
      params: {}
    };
  },
  props: {
    job: Object,
    job_ids: Array,
    all_jobs: Array,
    apply: Boolean,
    view: Boolean,
    company: Boolean,
    arrow: Boolean,
    match: Boolean,
    recommended: Boolean,
    accept: Boolean,
    applied: Boolean,
    highlight: Boolean,
    closed: Boolean,
    open: Boolean,
  },
  async created() {
    await this.fetchData();
  },
  async mounted() {

  },
  watch: {
    $route: "fetchData",
    job: {
      immediate: true,
      deep: true,
      handler() {
        this.user = JSON.parse(localStorage.getItem("user"));

        if (this.job.job_id) {
          this.params["id"] = this.job.job_id;
        }

        if (this.job.id) {
          this.params["id"] = this.job.id;
        }

        if (this.job_ids) {
          this.params["job_ids"] = this.job_ids;
        }

        if (this.all_jobs && this.all_jobs.length > 1) {
          this.params["job_ids"] = this.all_jobs.map(({ job_id }) => job_id);
        }

        if (this.recommended) {
          this.params["action"] = "apply";
          // this.params["job_ids"] = this.job_ids;
          this.params["matched_job_id"] = parseInt(this.params["id"]);
        } else if (this.match) {
          this.params["action"] = "apply";
        } else if (this.accept) {
          this.params["action"] = "accept";
          this.params["matched_applicant_id"] = parseInt(
            this.job.matched_applicant_id
          );
        } else if (this.applied) {
          this.params["action"] = "applied";
          if(this.job.is_declined) {
            this.params["action"] = "declined";
          }
        } else if (this.closed) {
          this.params["action"] = "closed";
        } else if (this.arrow) {
          this.params["action"] = "view";
        } else if (!this.params["action"]) {
          this.params["action"] = "view";
        }

        if (this.job.working_dates || this.job.hired_dates) {
          try {
            let working_dates = this.job.hired_dates
            ? JSON.parse(this.job.hired_dates)
            : JSON.parse(JSON.parse(this.job.working_dates));

            let working_dates_length = Object.keys(working_dates).length;
            let formatedFirstDate = new Date(Object.keys(working_dates)[0]).toLocaleDateString();
            let _subtitle = "";
            let locationType = "";
            if (this.branch == 2) {
              locationType = this.job.discipline_id == 68 ? " (BSO)" : " (dagopvang)";
            }

            if(this.user.type == 2 && !this.job.hired_dates) {
              if(this.job.unmatched_reasons) {
                try {
                  let unmatched_reasons = JSON.parse(this.job.unmatched_reasons);
                  if(unmatched_reasons && unmatched_reasons.dates) {
                    working_dates_length = Object.keys(working_dates).length - unmatched_reasons.dates.length;
                  }
                } catch (error) {
                  console.error('Error parsing unmatched_reasons:', error);
                }
              }
            }

            if (Object.keys(working_dates).length > 1) {
              _subtitle = [formatedFirstDate, working_dates_length + " dagen" + locationType];
            }
            else if(Object.keys(working_dates).length > 0)
            {
              _subtitle = [formatedFirstDate, "één dag" + locationType];
            }
            else {
              _subtitle = [formatedFirstDate, working_dates_length + " dagen" + locationType];
            }
            this.subtitle = _subtitle;
          } catch (error) {
            console.error('Error parsing working_dates:', error);
          }
        }
      }
    }
  },
  methods: {
    getFirstWorkingDate() {
      try {
        let working_dates = this.job.hired_dates
            ? JSON.parse(this.job.hired_dates)
            : JSON.parse(JSON.parse(this.job.working_dates));
        return new Date(Object.keys(working_dates)[0]).toLocaleDateString();
      } catch (error) {
        console.error('Error parsing working_dates in getFirstWorkingDate:', error);
        return 'Onbekend';
      }
    },
    getLastWorkingDate() {
      try {
        let working_dates = this.job.hired_dates
            ? JSON.parse(this.job.hired_dates)
            : JSON.parse(JSON.parse(this.job.working_dates));
        return new Date(Object.keys(working_dates)[Object.keys(working_dates).length - 1]).toLocaleDateString();
      } catch (error) {
        console.error('Error parsing working_dates in getLastWorkingDate:', error);
        return 'Onbekend';
      }
    },
    async fetchData() {
      // compute applicants??? Bekijk aanbevelingen
      if (this.job.job_id || this.job.id) {
        // var user = JSON.parse(localStorage.getItem("user"));
        // var ID = parseInt(this.job.id);
        // if company
        // if (user.type == 2) {
        // this.view = true;
        // this.applicants = await this.getTokenAPIList("applicants/" + ID);
        // this.applicants = await this.getTokenAPIList("applicants/" + ID);
        // }
        try {
          if (this.job.audience) {
            this.formattedAudience = JSON.parse(this.job.audience).join(', ');
          }
          if (this.job.group && this.sub_branch == '2') {
              this.formattedGroup = JSON.parse(this.job.group).join(', ');
          }
        } catch (error) {
          console.error('Error parsing job data:', error);
          // Set default values if parsing fails
          if (this.job.audience && !this.formattedAudience) {
            this.formattedAudience = this.job.audience;
          }
          if (this.job.group && !this.formattedGroup) {
            this.formattedGroup = this.job.group;
          }
        }
      }
    },
    async editJob() {
      localStorage.setItem("job", JSON.stringify(this.job));
      this.$router.replace({ name: "job_step-1" });
    },
    async deleteJob() {
      const ID = parseInt(this.job.job_id);
      await this.deleteRecord("/job/" + ID);
      // continue only if resolve()
      this.$router.replace({ name: "company-dashboard" });
    },
    async onAccept(id) {
      this.$store.state.loading = true;
      await this.acceptJob(id);
      // continue if it was accepted
      window.scrollTo(0, 0);
      this.$emit("input", "accepted"); // fullscreen_notif
    }
  }
};
</script>

<style scoped>

.card .card-top-row {
  display: grid;
  grid-auto-flow: column;
  position: absolute;
  top: -15px;
  width: 100%
}

.card.declined {
  filter: grayscale(1);
}

.card.declined .card-top-row .declined {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 0px;
  font-weight: 400;
  height: 25px;
  width: 85px;
  background-color: #F6F6F6;
}

.card .card-top-row .match_percentage {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  font-weight: normal;
  height: 25px;
  width: 85px;
  border-radius: 10px;
  font-size: 12px;
  color: #64513d;
  background-color: #FFCD00;
  margin-left: 15px;
}

.card .card-top-row .bell {
  margin-right: 15px;
  justify-self: flex-end;
  background-color: #FFF;
}

.jobCardSpecs .duration_type {
  border-radius: 10px;
  font-size: 12px;
  padding: 3px 15px;
  margin-left: 5px;
}

.jobCardSpecs .duration_type.recent {
  height: 25px;
  background-color: #F6F6F6;
}

.jobCardSpecs .duration_type.recent_yellow {
  height: 25px;
  background-color: #FFF9E2;
}

.margin-bottom-2 {
  margin-bottom: 2rem;
}

.job-link .card {
  border: 2px solid #f6f6f6;
  border-radius: 10px;
}

.job-link .card-body {
  padding: 25px;
}

.job-link .card-body-inner {
  display: flex;
  align-items: center;
}

.job-link .card-body-inner.company-card {
  margin-bottom: 20px;
}

.jobCardSpecs-image {
  position: relative;
  height: 85px;
  min-width: 85px;
  border-radius: 100px;
  border: 2px solid #f6f6f6;
  background-size: cover;
  background-position: center center;
  margin-right: 18px;
  overflow: hidden;
}

.jobCardSpecs-image .img-item {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.jobCardSpecs-image .img-item /deep/svg {
  width: 100%;
  height: 100%;
  padding: 15px;
}

.jobCardSpecs a {
  color: #64513d;
}

.jobCardSpecs ul {
  font-size: 12px;
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.jobCardSpecs ul li {
  display: flex;
  align-items: center;
}

.jobCardSpecs ul li:not(:last-child) {
  margin-bottom: 10px;
}

/deep/ .jobCardSpecs ul li .svg-container {
  display: flex;
  align-items: center;
}

/deep/ .jobCardSpecs ul li svg {
  color: #ffcd00;
  width: 15px;
  max-height: 15px;
  margin-right: 6px;
}

.job-link .card .control-bar-bottom,
.job-link .card .control-bar-top {
  display: flex;
  align-items: center;
}

.job-link .card .control-bar-top {
  margin-bottom: 10px;
  margin-right: 50px;
}

.job-link .card .control-bar-top .sd-button {
  width: 100%;
}

.job-link .card .control-bar .sd-button:not(:last-child) {
  margin-right: 10px;
}

.job-link .card .control-bar-bottom .sd-button {
  background-color: #F6F6F6;
  font-weight: 400;
  color: #64513D;
  width: 100%;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
}

.job-link .card .control-bar .sd-button.delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64513D;
  min-width: 40px;
  height: 40px;
  border-radius: 100%;
  width: unset;
}

/deep/.job-link .card .control-bar .sd-button.delete svg {
  height: 15px;
  width: 15px;
}

.job-link .card .people-overview {
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: 10px;
}

.job-link .card .people-overview:not(:last-child) {
  margin-bottom: 10px;
}

.job-link .card .people-overview .profile-circle {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  background-color: #F6F6F6;
  color: #64513D;
  font-size: 12px;
}

/deep/.job-link .card .icon-wrapper .svg-container {
  color: #64513D;
}

@media screen and (max-width: 500px) {
  .job-link .card .control-bar-top,
  .job-link .card .control-bar-bottom {
    flex-direction: column;
  }

  .job-link .card .control-bar-top {
    margin-right: 0;
  }

  .job-link .card .control-bar .sd-button:not(:last-child) {
    margin-right: 0;
    margin-bottom: 10px;
  }

}

</style>